<template>
  <CustomerDashboardComponent :customerid="this.$route.params.customerid" />
</template>

<script>
import CustomerDashboardComponent from "@/sections/voiceplus/components/CustomerDashboardComponent.vue";
import config from "@/config";

export default {
  name: "CustomerDashboard",
  components: { CustomerDashboardComponent },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>
